export const _en = {
    id: {
        label: "Id"
    },
    resourceType: {
        label: "Resource type"
    },
    resourceUid: {
        label: "Number"
    },
    name: {
        label: "Name"
    },
    firstName: {
        label: "First name"
    },
    phone: {
        label: "Phone number"
    },
    email: {
        label: "Email"
    },
    isNoName: {
        label: "Is anonymous resource"
    },
    capacity: {
        label: "Seats capacity"
    },
    refSiteId: {
        label: "Location"
    },
    divisionId: {
        label: "Division"
    },
    resourceCapacity: {
        label: "Resource capacity"
    },
    refServiceProvider: {
        label: "Service Provider company"
    },
    refGlobalStateId: {
        label: "State"
    },
    isIntOrExt: {
        label: "External resource"
    },
    isLegacyCertified: {
        label: "Validated legacy"
    },
    address: {
        label: "Address"
    },
    floor: {
        label: "Stage"
    },
    number: {
        label: "Number"
    },
    refMotorVersionsIds: {
        label: "Engine"
    },
    motion: {
        label: "Motion"
    },
    refPlaneTypesId: {
        label: "Plane type"
    },
    comment: {
        label: "Comment"
    },
    interSessionTime: {
        label: "Time need Between Session"
    },
    shortName: {
        label: "Short name"
    }
};

export const _fr = {
    id: {
        label: "Identifiant"
    },
    resourceType: {
        label: "Type de ressource"
    },
    resourceUid: {
        label: "Matricule"
    },
    name: {
        label: "Nom"
    },
    firstName: {
        label: "Prénom"
    },
    phone: {
        label: "Numéro de téléphone"
    },
    email: {
        label: "Adresse mail"
    },
    isNoName: {
        label: "Est une ressource anonyme"
    },
    capacity: {
        label: "Capacité (nombre de places)"
    },
    refSiteId: {
        label: "Site"
    },
    divisionId: {
        label: "Service"
    },
    resourceCapacity: {
        label: "Capacité"
    },
    refServiceProviderId: {
        label: "Société"
    },
    refGlobalStateId: {
        label: "État"
    },
    isIntOrExt: {
        label: "Ressource externe"
    },
    isLegacyCertified: {
        label: "Validé DGAC"
    },
    address: {
        label: "Adresse"
    },
    floor: {
        label: "Étage"
    },
    number: {
        label: "Numéro"
    },
    refMotorVersionsIds: {
        label: "Versions"
    },
    motion: {
        label: "Motion"
    },
    refPlaneTypesId: {
        label: "Type avion"
    },
    comment: {
        label: "Commentaire"
    },
    interSessionTime: {
        label: "Durée entre séances"
    },
    shortName: {
        label: "Code"
    }
};